<div class="d-flex flex-column justify-content-center align-items-center">
  <span class="fa fa-exclamation-triangle something-went-wrong-icon text-gray-300 mt-4"></span>
  <h4 class="mt-3 mb-0">{{ 'mbs-ui:something-went-wrong.title' | i18next }}</h4>
  <p class="pre-wrap text-center mb-3">{{ 'mbs-ui:something-went-wrong.description' | i18next }}</p>
  <div class="row">
    <div class="col-auto">
      <mbs-button [type]="'primary'"
                  [icon]="'fa fa-repeat'"
                  (click)="refresh.emit()">
        {{ 'shared:buttons.refresh' | i18next: { format: 'title'} }}
      </mbs-button>
    </div>
  </div>
</div>
